import { render, staticRenderFns } from "./InvitationToOrganizationPage.vue?vue&type=template&id=08ab694d&"
import script from "./InvitationToOrganizationPage.vue?vue&type=script&lang=js&"
export * from "./InvitationToOrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports